import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { AlertCircle, X } from 'lucide-react';

/**
 * Overlay affiché sur les pages restreintes quand l'essai est expiré
 * Bloque l'accès avec un fond blanc semi-transparent et affiche un CTA d'abonnement
 * Peut être fermé temporairement pour tester les fonctionnalités
 */
const TrialExpiredOverlay = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center"
      data-testid="trial-expired-overlay"
    >
      {/* Backdrop blanc avec opacité */}
      <div className="absolute inset-0 bg-white/70" />
      
      {/* Message card */}
      <div className="relative z-[101] max-w-md mx-4">
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-8 text-center">
          {/* Bouton de fermeture */}
          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            data-testid="close-trial-overlay-btn"
            aria-label="Fermer temporairement"
          >
            <X className="w-5 h-5" />
          </button>
          
          {/* Icon */}
          <div className="mx-auto w-16 h-16 bg-[#C53030]/10 rounded-full flex items-center justify-center mb-6">
            <AlertCircle className="w-8 h-8 text-[#C53030]" />
          </div>
          
          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Période d'essai terminée
          </h2>
          
          {/* Message */}
          <p className="text-gray-600 mb-6 leading-relaxed">
            Abonnez-vous pour continuer de profiter des fonctionnalités
          </p>
          
          {/* CTA */}
          <Button
            onClick={() => navigate('/admin/settings?tab=subscription')}
            className="w-full bg-[#1B4332] hover:bg-[#0D2E1F] text-white font-semibold h-12 text-base"
            data-testid="trial-expired-overlay-cta"
          >
            S'abonner maintenant
          </Button>
          
          {/* Secondary link */}
          <button
            onClick={() => navigate('/dashboard')}
            className="mt-4 text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            Retour au tableau de bord
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpiredOverlay;
